import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function OnError(props = { handleTryAgain: () => {} }) {
  const { handleTryAgain } = props;
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-lg w-full h-[80dvh] flex flex-col gap-3 justify-center items-center">
      <div>{t("text_failed_load_magazine")}</div>
      <Button
        style={{ borderColor: "white", backgroundColor: 'var(--primary-button-color)', color: 'var(--primary-button-text-color)', height: '35px' }}
        onClick={handleTryAgain}
      >
        {t("text_try_again")}
      </Button>
    </div>
  );
}
